import axiosApiInstance from "../../../../api/axiosApiClient";
import { InternalAPIError } from "../../../../utils/apiErrors";
import { handleApiError } from "../../../../utils/globalErrorHandler";
const BASE_MKSRELEASE_API_URL = process.env.REACT_APP_MKS_API_URL;


export const currentRelease = [
  {
    id: 1,
    versionName: "v2.3.0",
    title: "AI Enhancement Release",
    description: "Major improvements in AI performance and usability.",
    releaseDate: "2026-03-01",
    items: [
      {
        id: 1,
        title: "New AI Dashboard",
        description: "Redesigned dashboard with better analytics.",
        itemType: 1,
        videoUrl: "https://www.youtube.com/embed/uGWN5PBx5ss"
      }
    ]
  },
  {
    id: 2,
    versionName: "v2.3.0",
    title: "AI Enhancement Release",
    description: "Major improvements in AI performance and usability.",
    releaseDate: "2026-03-01",
    items: [
      {
        id: 2,
        title: "API Performance Boost",
        description: "Optimized backend APIs.",
        itemType: 2,
        videoUrl: "https://www.youtube.com/embed/gJMb1hKKVlo"
      }
    ]
  },
  {
    id: 3,
    versionName: "v2.3.0",
    title: "AI Enhancement Release",
    description: "Major improvements in AI performance and usability.",
    releaseDate: "2026-03-01",
    items: [
      {
        id: 3,
        title: "Login Bug Fix",
        description: "Resolved session timeout issue.",
        itemType: 3,
        videoUrl: "https://www.youtube.com/embed/ZyscWIc3AHI"
      }
    ]
  }, {
    id: 3,
    versionName: "v2.3.0",
    title: "AI Enhancement Release",
    description: "Major improvements in AI performance and usability.",
    releaseDate: "2026-03-01",
    items: [
      {
        id: 3,
        title: "Login Bug Fixes",
        description: "Resolved session timeout issue.",
        itemType: 3,
        videoUrl: "https://www.youtube.com/embed/ZyscWIc3AHI"
      }
    ]
  }
];

export const upcomingRelease = [{
  id: 2,
  versionName: "v2.4.0",
  title: "Automation Expansion",
  description:
    "Next release will introduce automation workflows and improved integrations.",
  releaseDate: "2026-06-15",
  ImageUrl:
    "https://images.unsplash.com/photo-1518770660439-4636190af475"
}, {
  id: 3,
  versionName: "v2.4.0",
  title: "Automation Expansionsdfsdfsdf",
  description:
    "sdfsdfsdffNext release will introduce automation workflows and improved integrations.",
  releaseDate: "2026-06-15",
  ImageUrl:
    "https://images.unsplash.com/photo-1518770660439-4636190af475"
}];


export const getUpcomingReleaseInfo = async () => {
  try {
    const response = await axiosApiInstance.get(
      `${BASE_MKSRELEASE_API_URL}release/GetUpcomingReleases`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};

export const getCurrentReleaseInfo = async () => {
  try {
    const response = await axiosApiInstance.get(
      `${BASE_MKSRELEASE_API_URL}release/GetCurrentReleases`
    );
    if (response.status === 200) {
      return response.data;
    } else {
      handleApiError(new InternalAPIError());
    }
  } catch (error) {
    handleApiError(new InternalAPIError());
  }
};